import { fetchUserInfo } from './auth.service';

export const pushUser = async (token) => {
  const res = await fetchUserInfo(token);
  window?.dataLayer?.push({
    event: 'login',
    // username: res?.data?.username,
    // fullname: res?.data?.fullname,
    // is_super: res?.data?.is_super,
    ...res?.data,
  });
  return res?.data;
};
